// extracted by mini-css-extract-plugin
export var formContainer = "_dr-0";
export var message = "_dr-1";